import { RequestMethod } from '..';
import { BaseService } from './BaseService';

export interface ILoginInterface {
  assumedBy: string;
  accountId: string;
  authSource: string;
  authScope: string;
}

export class SansAuthService extends BaseService {

  constructor() {
    super({ configPath: 'services.auth' });
  }

  async sessionAuth(spCookie: string, spTokenCookie: string) {
    const response = await this.requestResource('session', {
      tokenType: 'none',
      method: RequestMethod.POST,
      data: {
        sp: spCookie,
        spToken: spTokenCookie,
      },
    });

    return response;
  }

  async login({
    accountId,
    assumedBy,
    authSource,
    authScope,
  }: ILoginInterface) {
    const response = await this.requestResource('service.login', {
      sign: true,
      method: RequestMethod.POST,
      data: {
        accountId,
        assumedBy,
        authScope,
        authSource,
      },
    });

    return response;
  }
}

export default SansAuthService;
